import React from 'react';
import _partial from 'lodash/partial';
import _debounce from 'lodash/debounce';
import {bindMethods, setRef} from '../../utilities/componentHelpers';
import {IFRAME_VIDEO_KEY} from '../../utilities/constants';

const RESIZE_TIMEOUT = 50;

/**
 * IframedVideo Component
 */
export default class IframedVideo extends React.Component {
  static propTypes = {
    aspect: React.PropTypes.number.isRequired,
    isModal: React.PropTypes.bool,
    url: React.PropTypes.string.isRequired,
    videoReadyCallback: React.PropTypes.func,
  };

  /**
   * IframedVideo Component Constructor
   * @param  {Object} props Passed in properties
   * @return {Undefined} Returns nothing
   */
  constructor(props) {
    super(props);

    /* refs */
    this[IFRAME_VIDEO_KEY] = null;
    this.setVideoRef = _partial(
      setRef,
      _partial.placeholder,
      IFRAME_VIDEO_KEY,
      this
    );

    bindMethods(this, ['handleOnLoad', 'handleResize']);

    this.handleResize = _debounce(this.handleResize, RESIZE_TIMEOUT);
  }

  /**
   * Lifecycle Method
   * @return {Undefined} Returns nothing
   */
  componentDidMount() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
    setTimeout(this.handleResize, RESIZE_TIMEOUT);
    this[IFRAME_VIDEO_KEY].addEventListener('load', this.handleOnLoad);
  }

  /**
   * Lifecycle Method
   * @return {Undefined} Returns nothing
   */
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    this[IFRAME_VIDEO_KEY].removeEventListener('load', this.handleOnLoad);
  }

  /**
   * Triggers frame sizing upon load of the video
   * @return {Undefined} Returns nothing
   */
  handleOnLoad() {
    this.handleResize();
    if (
      this.props.videoReadyCallback &&
      typeof this.props.videoReadyCallback === 'function'
    ) {
      this.props.videoReadyCallback();
    }
  }

  /**
   * Maintains the aspect of the Iframed video
   * @return {Undefined} Returns nothing
   */
  handleResize() {
    const width = this[IFRAME_VIDEO_KEY].clientWidth;

    this[IFRAME_VIDEO_KEY].height = width * this.props.aspect;
  }

  /**
   * React Component render
   * @return {JSX} IframedVideo rendered
   */
  render() {
    const {isModal, url} = this.props;

    return (
      <div>
        <iframe
          allowFullScreen={isModal}
          ref={this.setVideoRef}
          src={url}
          width="100%"
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/reactModules/shared/library/IframedVideo/IframedVideo.js